import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
import request from '../../service';
import Exported from '../../service/endpoints';
import { useDispatch } from 'react-redux';
import { Toast } from '../../service/toast';
import { saveLoadingState } from '../../redux/reducers/loadingSlice';
import ModalDropdown from '../../component/ModalDropdown';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, useForm, Controller } from 'react-hook-form';
import Button from '../../component/Button';
import InputBox from '../../component/InputBox';
import RedeemList from './components/RedeemList';
import RedeemRewardDetails from './components/RedeemDetails';
import SelectBox from '../../component/SelectBox';

const RedeemRewards = () => {
    const ORDER_PLACED = 'Order Placed'
    const ORDER_DELIVERED = 'Order Delivered'
    const ORDER_CANCELLED = 'Order Cancelled'
    const ORDER_REJECTED = 'Order Rejected'
    const productList = [ORDER_PLACED, ORDER_DELIVERED, ORDER_CANCELLED, ORDER_REJECTED ];
    const dropdownList = [
      { label: "Order Canceled", value: 4 },
      { label: "Order Rejected", value: 5 },
      { label: "Order Delivered", value: 3 },
    ];
    const dropdownListRefund = [
      { label: "Approve Refund", value: 1, },
      { label: "Reject Refund", value: 0, },
    ];
    const [ids, setIds] = useState([]);
    const [viewRedeem, setViewRedeem] = useState(false)
    const [searchInput, setSearchInput] = useState('')
    const [sortSelected, setSortSelected] = useState(null)
    const [isDropdown, setIsDropdown] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [prodId, setProdId] = useState()
    const [isChecked, setIsChecked] = useState(false)
    const [activeTab, setActiveTab] = useState(ORDER_PLACED)
    const [selectedOrderStatus, setSelectedOrderStatus] = useState("");
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const formMethods = useForm({
        mode: 'onChange', // Change mode to onChange for better validation
        defaultValues: {
            productStatus: '', // Add default value
            reason: ''
        }
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
        control, // Add control from form methods
        reset, // Use reset instead of resetField
    } = formMethods;

    useEffect(() => {
        if (location?.pathname) {
            const pathName = location?.search?.split('?id=')
            const params = pathName[pathName?.length - 1]
            if (params) {
                setViewRedeem(true)
            } else {
                setViewRedeem(false)
            }
        }
    }, [location])

    const handleChange = (value) => {
        setSearchInput(value)
    }

    const redirectTo = () => {
        navigate(`?type=create`)
    }
    const handleStatus = (id) => {
        console.log(id)
        setProdId(id)
        setIsOpen(true);
       
    }

    const closePopUp = () =>{
        reset(); // Reset form when closing
        setIsOpen(false);
        setSelectedOrderStatus("")
    }

    const onSubmit = async (data) => {
        try {
          const isRefunded = data.refundStatus === 1;
          const url =
            ids.length > 1
              ? `${Exported.Endpoints.redeemRewardsItem}/selected`
              : `${Exported.Endpoints.redeemRewardsItem}/${
                  data.productStatus === 3
                    ? "delivered"
                    : data.productStatus === 4
                    ? "canceled"
                    : "rejected"
                }?redeem_id=${prodId}`;
            dispatch(saveLoadingState(true));
            await request({
              url: url,
              method: Exported.APIMethods.POST,
              data: {
                message: data?.reason,
                status: data?.productStatus,
                is_refunded: isRefunded,
                ...(ids.length > 1 ? {id: ids} : {})
              }
            });
            
            setIsChecked(true);
            reset(); // Reset all form fields
            setIsOpen(false);
            
            Toast({
                type: 'success',
                message: 'Status updated successfully'
            });
        } catch (err) {
            console.log(err, "err");
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            });
        } finally {
            dispatch(saveLoadingState(false));
        }
    };

    return (
      <>
        {viewRedeem ? (
          <RedeemRewardDetails />
        ) : (
          <div className={`${classes.manageUserWrapper}`}>
            <div className={`w-[100%] flex items-center justify-between`}>
              <div className={`layout-title`}>Redeem Rewards</div>
              <div className="flex items-center">
                <SearchBox
                  value={searchInput}
                  onChange={handleChange}
                  placeholder={"Find by Customer Name"}
                />
              </div>
            </div>
            <div className={`${classes.headerList} w-[100%] flex items-center`}>
              {productList?.map((title) => (
                <div
                  className={`${classes.headerTab} ${
                    activeTab === title ? classes.activeTab : ""
                  }`}
                  onClick={() => setActiveTab(title)}
                >
                  {title}
                </div>
              ))}
            </div>
            {(ids?.length > 1 && activeTab === ORDER_PLACED) && (
                  <div class="d-flex justify-content-end align-items-end">
                  <Button
                    onClick={() => setIsOpen(true)}
                    text={"Send"}
                    className={`my-4`} // Add margin as needed
                    smallBtn
                  />
                </div>
            )}
            <div>
              <RedeemList
                ids={ids}
                setIds={setIds}
                searchInput={searchInput}
                handleStatus={handleStatus}
                checked={isChecked}
                currentTab={activeTab}
              />

            </div>
          </div>
        )}
        {isOpen ? (
          <ModalDropdown isOpen={isOpen} closePopUp={closePopUp}>
            <div className={`${classes.reasonModalWrapper}`}>
              <div
                className={`${classes.modalHeader} flex items-center justify-between`}
              >
                <div className={`${classes.modalTitle}`}>
                  Add Internal Comment
                </div>
                <div className={`${classes.modalCloser}`}>
                  <CloseIcon onClick={() => closePopUp()} />
                </div>
              </div>
              <div className={`${classes.reasonFormContainer}`}>
                <FormProvider {...formMethods}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={`${classes.formField}`}>
                        <Controller
                          name="productStatus"
                          control={control}
                          defaultValue=""
                          rules={{ required: "Status is required" }}
                          render={({ field }) => (
                            <SelectBox
                              label="Order Status"
                              placeholder="Order Status"
                              list={dropdownList}
                              value={field.value}
                              isEdit={false}
                              {...field}
                              error={errors.productStatus}
                              messages={{
                                required: "Status is required"
                              }}
                              onChange={(e) => {
                                field.onChange(e);
                                setSelectedOrderStatus(e); 
                              }}
                            />
                          )}
                        />
                    </div>
                    {(selectedOrderStatus === 4 || selectedOrderStatus === 5) && (
                    <div className={`${classes.formField}`}>
                        <Controller
                          name="refundStatus"
                          control={control}
                          defaultValue={1} 
                          rules={{ required: "Refund status is required" }}
                          render={({ field }) => (
                            <SelectBox
                              label="Refund Status"
                              placeholder="Refund Status"
                              list={dropdownListRefund}
                              defaultValue = {1}
                              value={field.value || 1} 
                              isEdit={false}
                              {...field}
                              error={errors.refundStatus}
                              messages={{
                                required: "Refund status is required"
                              }}
                            />
                          )}
                        />
                    </div>
                    )}
                    <div className={`${classes.formField}`}>
                      <InputBox
                        label={"Comment"}
                        className={`w-[100%] ${classes.notesInput}`}
                        name={"reason"}
                        type={"textarea"}
                        {...register("reason", {
                          required: "Reason is required"
                        })}
                        error={errors.reason}
                        messages={{
                          required: "Reason is required"
                        }}
                      />
                    </div>
                    <div className="flex justify-end">
                      <Button
                        text={"Submit"}
                        className={`w-[100%] my-4`}
                        smallBtn
                        type="submit"
                      />
                    </div>
                  </form>
                </FormProvider>
              </div>
            </div>
          </ModalDropdown>
        ) : null}
      </>
    );
}

export default RedeemRewards